// Depends on tag_renderer.js
/**
 * LI item producer for rendering list names inside popups,
 * like "ll" or "mm" or in completion of lists
 */

import clsx from 'clsx';
import {GoDeeperArrow} from './go_back_forward_arrow';
import * as React from 'react';

interface ChecklistPopupRendererProps {
    listData: ListData;
    extraLiClass?: string;
    highlighter: (txt: String) => JSX.Element;

    forwardAction?: (e: Event) => void;
    forwardRunning: boolean;
}

const ChecklistPopupRenderer = (props: ChecklistPopupRendererProps) => {

    const item = props.listData;
    var onClick = "return true;";
    var tags = maxkir.TagRenderer.renderTagMap(props.listData.tags, onClick, true);

    var id = item.id;
    var classes = clsx("popupChecklistLi", props.extraLiClass, item.read_only ? "popupChecklistLi--readOnly": null);

    return <li className={classes} id={"popup_checklist_" + id} data-list-id={id} key={"popup_checklist_" + id}>
        <div className="popupChecklistLi__main">
            <a href={'/checklists/' + id} className="popupChecklistLi__a" target="_self">
                {props.highlighter(item.name)}
            </a>
            {tags !== '' &&
              <div className="popupChecklistLi__tags" dangerouslySetInnerHTML={{__html: tags}}/>
            }
        </div>
        <GoDeeperArrow forwardAction={props.forwardAction} running={props.forwardRunning}/>
    </li>;
}

export default ChecklistPopupRenderer;
